<!-- @ts-nocheck -->
<template>
  <q-item-label v-if="isEnabled" v-bind="$attrs">
    <slot />
  </q-item-label>
  <div v-else variant="custom" v-bind="$attrs">
    <div class="font-normal leading-normal text-sm visible cursor-pointer m-0 p-0 w-auto min-w-0 max-w-full flex flex-wrap flex-col justify-center whitespace-nowrap     items-center gap-3 px-4 py-3 [transition:background-color_0.15s_ease] rounded-md hover:bg-gray-100">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpItemLabel");

defineOptions({
  name: "dtpItemLabel",
  inheritAttrs: true
});
</script>
